import { createAction, props } from '@ngrx/store';
import { CoreUiEntity } from './core-ui.models';
import { BrandDefaults, Colour, LoadedGiftCard, OpenOrder } from '@pos-app/data';

export const loadCoreUi = createAction('[CoreUi] Load CoreUi');

export const loadCoreUiSuccess = createAction('[CoreUi] Load CoreUi Success', props<{ coreUi: CoreUiEntity[] }>());

export const hasUnsavedChanges = createAction('[CoreUi] Has Unsaved Changes', props<{ unsavedChanges: boolean }>());

export const loginSuccess = createAction('[CoreUi] Login Success', props<{ payload: any }>());

export const loadCoreUiFailure = createAction('[CoreUi] Load CoreUi Failure', props<{ error: any }>());

export const clearUnsavedChanges = createAction('[CoreUi] Clear Unsaved Changes', props<{ unsavedChanges: boolean }>());

export const navigateToUrl = createAction('[CoreUi] Navigate to Url', props<{ url: string }>());

export const createQuickSale = createAction('[CoreUi] Open quick sale');

export const searchCustomers = createAction('[CoreUi] Search customers', props<{ customerfuzzySearch: string; customerType: string }>());

export const searchCustomersSuccess = createAction('[CoreUi] Search customers success', props<{ result: any }>());

export const searchCustomersFailed = createAction('[CoreUi] Search customers failed', props<{ errors: any }>());

export const clearSearchData = createAction('[CoreUi] Clear search data');

export const clearSearchJobOrderData = createAction('[CoreUi] Clear search job order data');

export const searchExternalCustomers = createAction('[CoreUi] Search External customers', props<{ searchString: string }>());

export const searchExternalCustomersSuccess = createAction('[CoreUi] Search External customers success', props<{ result: any }>());

export const searchExternalCustomersFailed = createAction('[CoreUi] Search External customers failed', props<{ errors: any }>());

export const clearExternalSearchData = createAction('[CoreUi] Clear External search data');

export const hasActiveOrder = createAction(
  '[CoreUi] Has active order',
  props<{
    orderNumber: string;
    quickSaveAllowed?: boolean;
  }>()
);

export const setOpenOrder = createAction('[CoreUi] Set open order', props<{ openOrder: OpenOrder; quickSaveAllowed: boolean }>());

export const loadColourList = createAction('[CoreUi] Load colour list', props<{ colourList: Colour[] }>());

export const setSelectedVehicle = createAction(
  '[CoreUi] Set selected vehicle',
  props<{
    customerVehicleID: string;
    partsVehicleID: string | number;
    vehicleDescription: string;
    jdeVehicleID: string;
  }>()
);

export const setCashDrawer = createAction('[CoreUi] Set cash drawer', props<{ cashDrawer: string }>());

export const hasPendingPayments = createAction('[CoreUi] Has pending payments', props<{ hasPendingPayments: boolean }>());

export const hasPendingLineChangeTF = createAction('[CoreUi] Has pending line change TF', props<{ hasPendingLineChangeTF: boolean }>());

export const loadBrandDefaults = createAction('[CoreUi] Load brand defaults');

export const loadBrandDefaultsSuccess = createAction('[CoreUi] Load brand defaults success', props<{ result: BrandDefaults }>());

export const loadBrandDefaultsFailed = createAction('[CoreUi] Load brand defaults failed', props<{ errors: any }>());

export const hasIncompleteOrder = createAction('[Action] Has incomplete order', props<{ isIncompleteOrder: boolean }>());

export const hasLoadedGiftCard = createAction('[Action] Set loaded gift cards', props<{ hasLoadedGiftCards: boolean }>());

export const resetAllFlags = createAction('[Action] Reset all flags');

export const checkIsShowroomView = createAction('[CoreUi] Is Showroom View', props<{ isShowRoomView: boolean }>());

export const checkIsXRefPartsView = createAction('[CoreUi] Is Showroom View', props<{ isXRefPartsView: boolean }>());

export const hasOrderChanged = createAction('[CoreUi] Has order changed', props<{ isOrderChanged: any }>());

export const parkedOrderListLength = createAction('[CoreUi] Parked order list length', props<{ parkedOrderListLength: number }>());

export const loadedTotalOrderData = createAction('[CoreUi] Load Total Order Data Success', props<{ totalOrderData: any }>());

//load communication group list
export const loadCommunicationGroupList = createAction('[CoreUi] Load Communication Group List');
export const loadCommunicationGroupListSuccess = createAction(
  '[CoreUi] Load Communication Group List Success',
  props<{ communicationGroupList: any }>()
);
export const loadCommunicationGroupListFailed = createAction('[CoreUi] Load Communication Group List Failed', props<{ errors: any }>());

export const loadArbCentralNavSecurity = createAction('[CoreUi] Load Arb Central Nav Security');
export const loadArbCentralNavSecuritySuccess = createAction(
  '[CoreUi] Load Arb Central Nav Security Success',
  props<{ arbCentralNavSecurity: any }>()
);
export const loadArbCentralNavSecurityFailed = createAction('[CoreUi] Load Arb Central Nav Security Failed', props<{ errors: any }>());

export const fetchSiteList = createAction('[CoreUi] Fetch Site List');
export const fetchSiteListSuccess = createAction('[CoreUi] Fetch Site List Success', props<{ cachedSiteList: any }>());
export const fetchSiteListFailed = createAction('[CoreUi] Fetch Site List Failed', props<{ errors: any }>());

export const fetchSalesPeopleList = createAction('[CoreUi] Fetch Sales People List');
export const fetchSalesPeopleListSuccess = createAction('[CoreUi] Fetch Sales People List Success', props<{ cachedSalesPeopleList: any }>());
export const fetchSalesPeopleListFailed = createAction('[CoreUi] Fetch Sales People List Failed', props<{ errors: any }>());

export const saveCustomerOrderDetailsForTask = createAction(
  '[CoreUi] Customer Order Details For Task',
  props<{
    customerOrderDetails?: any;
  }>()
);
export const customerOrderDetailsForTaskSuccess = createAction(
  '[CoreUi] Customer Order Details For Task Success',
  props<{
    customerOrderDetails: any;
  }>()
);
export const customerOrderDetailsForTaskFailed = createAction(
  '[CoreUi] Customer Order Details For Task Failed',
  props<{
    errors: any;
  }>()
);

export const searchshipToCustomers = createAction(
  '[CoreUi] Search ShipTo customers',
  props<{
    customerNumber: number;
    customerfuzzySearch: string;
    customerType: string;
  }>()
);
export const searchshipToCustomersSuccess = createAction('[CoreUi] Search ShipTo customers success', props<{ result: any }>());
export const searchshipToCustomersFailed = createAction('[CoreUi] Search ShipTo customers failed', props<{ errors: any }>());
export const clearshipToSearchData = createAction('[CoreUi] Clear ShipTo search data');

export const searchJobOrder = createAction('[CoreUi] Search Job Order', props<{ jobSearchString: string }>());
export const searchJobOrderSuccess = createAction('[CoreUi] Search Job Order success', props<{ result: any }>());
export const searchJobOrderFailed = createAction('[CoreUi] Search Job Order failed', props<{ errors: any }>());

